var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_19)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.351 5.519-.94.94a1.45 1.45 0 0 1-2.05-2.05l.94-.94a.288.288 0 0 0-.408-.409l-.94.942a2.026 2.026 0 1 0 2.866 2.865l.941-.94a.288.288 0 0 0-.408-.408m2.335-4.385A2 2 0 0 0 5.254.54a2 2 0 0 0-1.433.593l-.942.941a.288.288 0 0 0 .408.408l.942-.94a1.44 1.44 0 0 1 1.024-.425 1.45 1.45 0 0 1 1.025 2.475l-.94.94a.288.288 0 0 0 .408.408l.94-.94a2.03 2.03 0 0 0 0-2.866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.48 2.931-1.73 1.73a.288.288 0 1 0 .408.408l1.73-1.73a.288.288 0 0 0-.407-.408"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_19"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.36.54h6.92v6.92H.36z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrLink);
export default __webpack_public_path__ + "static/media/fi-rr-link.53b3e8a2f102ef470eb49e94dcf1e4a8.svg";
export { ForwardRef as ReactComponent };